import { BadgeCheckIcon, NetworkIcon, RouteIcon, TrendingUpIcon } from 'lucide-react';
import type { ModuleInfo } from '../types/content';

export const modules: ModuleInfo[] = [
  {
    id: 'knowledge',
    name: 'Knowledge',
    summary: 'Sources, relationships, terminology, evidence, and provenance.',
    capabilities: ['Source libraries', 'Reviewed relationships', 'Governed terminology', 'Provenance trails'],
    icon: NetworkIcon,
  },
  {
    id: 'capability',
    name: 'Capability',
    summary: 'Assessments, feedback, development plans, and reassessment.',
    capabilities: ['Structured assessments', 'Evidence-based feedback', 'Development plans', 'Reassessment cycles'],
    icon: TrendingUpIcon,
  },
  {
    id: 'services',
    name: 'Services',
    summary: 'Requests, referrals, case review, and follow-up.',
    capabilities: ['Intake and requests', 'Purpose-specific referrals', 'Case review', 'Follow-up tracking'],
    icon: RouteIcon,
  },
  {
    id: 'credentials',
    name: 'Credentials',
    summary: 'Records of achievement, qualifications, and demonstrated capabilities.',
    capabilities: ['Achievement records', 'Qualifications', 'Demonstrated capabilities', 'Verifiable history'],
    icon: BadgeCheckIcon,
  },
];
